/* Publish by EComposer at 2026-10-08 14:03:49*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-li2p2yb86eh"]=  window.__ectimmers["ecom-li2p2yb86eh"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-li2p2yb86eh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-li2p2yb86eh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-comzc5td23t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-comzc5td23t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0vs4cnb3b63n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0vs4cnb3b63n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mhuzz5xyw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mhuzz5xyw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nwx67ideex').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nwx67ideex', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hab3v0sbcib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hab3v0sbcib', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m0rxti3l0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m0rxti3l0s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hxmgfyzfm1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hxmgfyzfm1m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zudmo9y5pm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zudmo9y5pm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0mavinejw0r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0mavinejw0r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2f14oust1oh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2f14oust1oh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5djoix385hw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5djoix385hw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jepdila9ias').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jepdila9ias', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-30jwp2ukq6w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-30jwp2ukq6w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mr6h4u7u02c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mr6h4u7u02c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-592uiq3sa9a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-592uiq3sa9a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-abmgpdw27w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-abmgpdw27w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nsur65xbalc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nsur65xbalc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ehncxa6qra').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ehncxa6qra', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z1ycssnzsb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z1ycssnzsb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c96pzdsv8pr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c96pzdsv8pr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nuj8ye0raw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nuj8ye0raw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-69njrqu2gww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-69njrqu2gww', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qjaqk5jhd27').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qjaqk5jhd27', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vt64106q7ul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vt64106q7ul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jot5ol780ea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jot5ol780ea', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5j3k3lojn1y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5j3k3lojn1y', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-h6is6cb2f7j"]=  window.__ectimmers["ecom-h6is6cb2f7j"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-h6is6cb2f7j"]["tja6css41"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-h6is6cb2f7j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h6is6cb2f7j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wsx9gfdxs5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wsx9gfdxs5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-67czuosii5b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-67czuosii5b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1trwfshzuqh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1trwfshzuqh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvyaaotfkik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvyaaotfkik', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b34ccl0rvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b34ccl0rvp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kbshnnqkjc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kbshnnqkjc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7qrci8s8fm2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7qrci8s8fm2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kj2clonraeh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kj2clonraeh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d1wxentwbe4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d1wxentwbe4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t8nbpi0herg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t8nbpi0herg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-obeo8j992g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-obeo8j992g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-51hm62jpdqt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51hm62jpdqt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pawr0jnb9ts').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pawr0jnb9ts', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ll78sp1pgr"]=  window.__ectimmers["ecom-ll78sp1pgr"] || {};
if(!this.$el)return;const t=this.isLive;let e=this.$el.querySelectorAll("[ecom-modal]");const i=this.id,o=function(n){if(window.EComModal)return n();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&n()});return}let s=0;const r= window.__ectimmers["ecom-ll78sp1pgr"]["tkcfmo7c9"] = setInterval(function(){window.EComModal?(clearInterval(r),n()):++s>=300&&clearInterval(r)},50)};e.length&&t&&o(function(){new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+i]})})

                    });
                    
                        document.querySelectorAll('.ecom-ll78sp1pgr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ll78sp1pgr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gpx2pb9x66k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gpx2pb9x66k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4drfgodvki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4drfgodvki', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tclvwzdotls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tclvwzdotls', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-oxh248qa98"]=  window.__ectimmers["ecom-oxh248qa98"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-oxh248qa98"]["bqa7gosmg"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-oxh248qa98').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oxh248qa98', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8shqjldz916').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8shqjldz916', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h4un7crjx6b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h4un7crjx6b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-740r41vk3i8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-740r41vk3i8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x339tnvhci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x339tnvhci', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tnu4i2gehns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tnu4i2gehns', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jtclyp3wll9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jtclyp3wll9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h144sk87ktr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h144sk87ktr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m4k3q7aakz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m4k3q7aakz', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bj8vd5pznc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bj8vd5pznc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mbvydtldwp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbvydtldwp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tvatt5kssh9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tvatt5kssh9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y2ktoctbioo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y2ktoctbioo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fs5anvvmuta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fs5anvvmuta', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9tpu31met9a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9tpu31met9a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-difo6eu6z6e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-difo6eu6z6e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zcu75stfoz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zcu75stfoz', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-142073wu4rnp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-142073wu4rnp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-48htn62aqys').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-48htn62aqys', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i4v9fftncis').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i4v9fftncis', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c91w67l9ll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c91w67l9ll', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}